import React from 'react'
import './TexteHaut.scss'


export default function TexteHaut({score, timer, niveau}) {

    return (
        <div className="texteHaut">
            <div className="niveau">Niveau : {niveau}</div>
            <div className="timer">{timer}</div>
            <div className="score">Score : {score}</div>
        </div>
    )
}
